module.exports = __webpack_public_path__ + "res/slot_file_icon.png";